import * as TypeGraphQL from "type-graphql";
export var SystemAlertScalarFieldEnum;
(function (SystemAlertScalarFieldEnum) {
    SystemAlertScalarFieldEnum["id"] = "id";
    SystemAlertScalarFieldEnum["type"] = "type";
    SystemAlertScalarFieldEnum["severity"] = "severity";
    SystemAlertScalarFieldEnum["title"] = "title";
    SystemAlertScalarFieldEnum["message"] = "message";
    SystemAlertScalarFieldEnum["source"] = "source";
    SystemAlertScalarFieldEnum["metadataModelName"] = "metadataModelName";
    SystemAlertScalarFieldEnum["metadataVersion"] = "metadataVersion";
    SystemAlertScalarFieldEnum["metadataJobId"] = "metadataJobId";
    SystemAlertScalarFieldEnum["metadataMetrics"] = "metadataMetrics";
    SystemAlertScalarFieldEnum["metadataErrorDetails"] = "metadataErrorDetails";
    SystemAlertScalarFieldEnum["metadataRecommendations"] = "metadataRecommendations";
    SystemAlertScalarFieldEnum["status"] = "status";
    SystemAlertScalarFieldEnum["acknowledgedBy"] = "acknowledgedBy";
    SystemAlertScalarFieldEnum["acknowledgedAt"] = "acknowledgedAt";
    SystemAlertScalarFieldEnum["resolvedBy"] = "resolvedBy";
    SystemAlertScalarFieldEnum["resolvedAt"] = "resolvedAt";
    SystemAlertScalarFieldEnum["resolutionNotes"] = "resolutionNotes";
    SystemAlertScalarFieldEnum["suppressedUntil"] = "suppressedUntil";
    SystemAlertScalarFieldEnum["escalationLevel"] = "escalationLevel";
    SystemAlertScalarFieldEnum["notificationChannels"] = "notificationChannels";
    SystemAlertScalarFieldEnum["createdAt"] = "createdAt";
    SystemAlertScalarFieldEnum["updatedAt"] = "updatedAt";
})(SystemAlertScalarFieldEnum || (SystemAlertScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(SystemAlertScalarFieldEnum, {
    name: "SystemAlertScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=SystemAlertScalarFieldEnum.js.map